import { READ, FORM_UPDATE } from '../../../../store/type'
import { ATTR_VALUE } from "./type";
export const mutations = {
    [ATTR_VALUE + READ]: (state, { data, fieldInfoList }) => {
        state.data = data
        state.fieldInfoList = fieldInfoList
    }
};